import React, { useState } from 'react';
import { getApiUrl } from '../services/horasService';

type LoginMode = 'portal' | 'admin';

interface LoginPageProps {
  onLoggedIn: (accessToken: string) => void;
}

const LoginPage: React.FC<LoginPageProps> = ({ onLoggedIn }) => {
  const [mode, setMode] = useState<LoginMode>('portal');
  const [idLogin, setIdLogin] = useState('');
  const [clave, setClave] = useState('');
  const [adminUser, setAdminUser] = useState('');
  const [adminPassword, setAdminPassword] = useState('');
  const [error, setError] = useState<string | null>(null);
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setError(null);
    setLoading(true);
    try {
      const base = await getApiUrl();
      const url = mode === 'portal' ? `${base}/auth/login` : `${base}/auth/login-admin`;
      const body =
        mode === 'portal'
          ? { idLogin: idLogin.trim(), clave }
          : { adminUser: adminUser.trim(), password: adminPassword };

      const res = await fetch(url, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(body),
      });

      if (!res.ok) {
        let msg = `Error ${res.status}`;
        try {
          const j = (await res.json()) as { error?: string };
          if (j.error) msg = j.error;
        } catch {
          /* ignore */
        }
        throw new Error(msg);
      }

      const data = (await res.json()) as { accessToken: string };
      sessionStorage.setItem('sdp_horas_token', data.accessToken);
      onLoggedIn(data.accessToken);
    } catch (err) {
      setError(err instanceof Error ? err.message : 'No se pudo iniciar sesión');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="login-shell">
      <h2></h2>
      <div className="tabs" role="tablist">
        <button
          type="button"
          className={mode === 'portal' ? 'active' : ''}
          onClick={() => setMode('portal')}
        >
          Acceso Clientes
        </button>
        <button
          type="button"
          className={mode === 'admin' ? 'active' : ''}
          onClick={() => setMode('admin')}
        >
          Acceso Neos
        </button>
      </div>
      <form onSubmit={handleSubmit}>
        {mode === 'portal' ? (
          <>
            <div className="field">
              <label htmlFor="idLogin">ID Login</label>
              <input
                id="idLogin"
                autoComplete="username"
                value={idLogin}
                onChange={(ev) => setIdLogin(ev.target.value)}
                required
              />
            </div>
            <div className="field">
              <label htmlFor="clave">Clave</label>
              <input
                id="clave"
                type="password"
                autoComplete="current-password"
                value={clave}
                onChange={(ev) => setClave(ev.target.value)}
                required
              />
            </div>
          </>
        ) : (
          <>
            <div className="field">
              <label htmlFor="adminUser">Usuario</label>
              <input
                id="adminUser"
                autoComplete="username"
                value={adminUser}
                onChange={(ev) => setAdminUser(ev.target.value)}
                required
              />
            </div>
            <div className="field">
              <label htmlFor="adminPassword">Contraseña</label>
              <input
                id="adminPassword"
                type="password"
                autoComplete="current-password"
                value={adminPassword}
                onChange={(ev) => setAdminPassword(ev.target.value)}
                required
              />
            </div>
          </>
        )}
        {error ? <div className="error">{error}</div> : null}
        <button type="submit" className="submit" disabled={loading}>
          {loading ? 'Ingresando…' : 'Ingresar'}
        </button>
      </form>
    </div>
  );
};

export default LoginPage;
